import React, { useState, useEffect, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './HeroSlider.css';

const HeroSlider = () => {
  const HIDE_TITLES = true; // temporary flag to hide all slide titles
  const { isMarathi } = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Hero slides data with your provided images and titles
  const heroSlides = [
    {
      id: 1,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-1.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-1.jpg',
      title: {
        marathi: 'चला उद्योजक होऊया !',
        english: 'Let\'s become entrepreneurs!'
      }
    },
    {
      id: 2,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-2.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-2.jpg',
      title: {
        marathi: 'राज्यस्तरीय कामगार भजन स्पर्धा - अमरावतीचा कामगार पुरुष संघ २०२३',
        english: 'State Level Workers Bhajan Competition - Amravati Workers\' Men\'s Association 2023'
      }
    },
    {
      id: 3,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-3.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-3.jpg',
      title: {
        marathi: 'राज्यस्तरीय कामगार भजन स्पर्धा - नागपूर १ चा महिला संघ २०२३',
        english: 'State Level Workers Bhajan Competition - Nagpur 1 Women\'s Team 2023'
      }
    },
    {
      id: 4,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-4.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-4.jpg',
      title: {
        marathi: '२७ वी राज्यस्तरीय लोकनृत्य स्पर्धा - २०२२-२३',
        english: '27th State Level Folk Dance Competition - 2022-23'
      }
    },
    {
      id: 5,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-5.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-5.jpg',
      title: {
        marathi: 'राज्यस्तरीय समरगीत / स्फूर्तिगीत स्पर्धा - २०२२-२३',
        english: 'State Level Samargeet / Spurgeet Competition - 2022-23'
      }
    },
    {
      id: 6,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-6.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-6.jpg',
      title: {
        marathi: 'राज्यस्तरीय कामगार केसरी व कुमार केसरी कुस्ती स्पर्धा २०२२-२३',
        english: 'State Level Workers Kesari and Kumar Kesari Wrestling Competition 2022-23'
      }
    },
    {
      id: 7,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-7.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-7.jpg',
      title: {
        marathi: 'राज्यस्तरीय महिला कबड्डी स्पर्धेतील थरारक क्षण - २०२३',
        english: 'Thrilling Moments from the State Level Women\'s Kabaddi Tournament - 2023'
      }
    },
    {
      id: 8,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-8.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-8.jpg',
      title: {
        marathi: 'राज्यस्तरीय पुरुष  कबड्डी स्पर्धेतील थरारक क्षण - २०२३',
        english: 'Thrilling Moments from the State Level Men\'s Kabaddi Tournament - 2023'
      }
    },
    {
      id: 9,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-9.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-9.jpg',
      title: {
        marathi: 'आर्चरी ट्रेनिंग सेंटर  (धनुर्विद्या प्रशिक्षण केंद्राचे उद्घाटन) - २०२३',
        english: 'Archery Training Center (Archery Training Center Inauguration) - 2023'
      }
    },
    {
      id: 10,
      image: 'https://mlwb.in/react-static-files/homepage-hero-slides/webp/hero-10.webp',
      fallback: 'https://mlwb.in/react-static-files/homepage-hero-slides/jpg/hero-10.jpg',
      title: {
        marathi: 'शुटींग रेंज चे उद्घाटन - २०२३',
        english: 'Shooting Range Opening - 2023'
      }
    }
  ];

  // Filter to hide slides 6-10 (only show slides 1-5)
  const visibleSlides = heroSlides.filter(slide => slide.id <= 5);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % visibleSlides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, visibleSlides.length]);

  // Pause auto-play on hover
  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  // Manual navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    // Resume auto-play after 10 seconds
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToPrevious = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + visibleSlides.length) % visibleSlides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  }, [visibleSlides.length]);

  const goToNext = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % visibleSlides.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  }, [visibleSlides.length]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'ArrowRight') goToNext();
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [goToPrevious, goToNext]);

  return (
    <div 
      className="hero-slider"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="region"
      aria-label={isMarathi() ? 'मुख्य हीरो स्लाइडर' : 'Main Hero Slider'}
    >
      <div className="hero-slider-container">
        {/* Background Images */}
        <div className="hero-slider-background">
          {visibleSlides.map((slide, index) => (
            <div
              key={slide.id}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              aria-hidden={index !== currentSlide}
            >
              <picture>
                <source srcSet={slide.image} type="image/webp" />
                <img 
                  src={slide.fallback} 
                  alt={isMarathi() ? slide.title.marathi : slide.title.english}
                  className="hero-slide-image"
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </picture>
              <div className="hero-slide-overlay"></div>
            </div>
          ))}
        </div>
        
        {/* Content */}
        <div className="hero-slider-content">
          {!HIDE_TITLES && (
            <div className="hero-slider-text">
              <h1 className="hero-slider-title">
                {isMarathi() ? visibleSlides[currentSlide].title.marathi : visibleSlides[currentSlide].title.english}
              </h1>
            </div>
          )}
        </div>

        {/* Navigation Arrows */}
        <button 
          className="hero-slider-nav hero-slider-prev"
          onClick={goToPrevious}
          aria-label={isMarathi() ? 'मागील स्लाइड' : 'Previous slide'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15,18 9,12 15,6"></polyline>
          </svg>
        </button>
        
        <button 
          className="hero-slider-nav hero-slider-next"
          onClick={goToNext}
          aria-label={isMarathi() ? 'पुढील स्लाइड' : 'Next slide'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9,18 15,12 9,6"></polyline>
          </svg>
        </button>

        {/* Slide Indicators */}
        <div className="hero-slider-indicators" role="tablist" aria-label={isMarathi() ? 'स्लाइड निर्देशक' : 'Slide indicators'}>
          {visibleSlides.map((_, index) => (
            <button
              key={index}
              className={`hero-slider-indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              role="tab"
              aria-selected={index === currentSlide}
              aria-label={`${isMarathi() ? 'स्लाइड' : 'Slide'} ${index + 1}`}
            />
          ))}
        </div>

        {/* Progress Bar */}
        <div className="hero-slider-progress">
          <div 
            className="hero-slider-progress-bar"
            style={{
              animationDuration: isAutoPlaying ? '5s' : '0s',
              animationPlayState: isAutoPlaying ? 'running' : 'paused'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
